<template>
  <div
    class="pe-bg"
    ref="peBg"
    :style="'top:' + pageIndex * -100 + '%;'"
    @touchstart="touchStart($event)"
    @touchend="touchEnd($event)"
  >
    <navbar ref="navbar" :pageIndex="pageIndex" @changePage="changePage" />
    <home-page ref="homePage" />
    <function-introduction ref="functionIntroduction" />
    <im-introduction ref="imIntroduction" />
    <payment-introduction ref="paymentIntroduction" />
    <about-us ref="aboutUs" />
    <!-- <app-download ref="appDownload"></app-download> -->
    <share-box ref="shareBox" />
  </div>
</template>
<script>
import navbar from "./modules/navbar";
import homePage from "./modules/home-page";
import appDownload from "./modules/app-download";
import functionIntroduction from "./modules/function-introduction";
import paymentIntroduction from "./modules/payment-introduction";
import imIntroduction from "./modules/im-introduction";
import aboutUs from "./modules/about-us";
import shareBox from "../public-modules/share";

export default {
  data() {
    return {
      refList: [
        "homePage",
        "functionIntroduction",
        "imIntroduction",
        "paymentIntroduction",
        "aboutUs",
      ],
      pageIndex: 0,
      startX: null,
      startY: null,
      endX: null,
      endY: null,
      isMove: false,
    };
  },
  components: {
    navbar,
    homePage,
    appDownload,
    functionIntroduction,
    paymentIntroduction,
    imIntroduction,
    aboutUs,
    shareBox,
  },
  created() {
    this.$nextTick(() => {
      this.init();
      // document.body.addEventListener('touchmove', function (event) {
      //   event.preventDefault();
      // });
      // alert(document.documentElement.clientHeight)
    });
  },
  methods: {
    init() {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
        /(Android)/i.test(navigator.userAgent) || 
				navigator.userAgent.indexOf("Linux") > -1
      ) {
        // alert(navigator.userAgent);
        if (this.$route.query.isDownload) {
          location.href =
            "itms-apps://itunes.apple.com/app/nanaco-中国生活支援アプリ/id1329328896";
        }
        this.$refs.shareBox.init();
      } else {
        this.$router.push("/");
      }
    },
    changePage(index) {
      this.$nextTick(() => {
        this.pageIndex = index;
      });
    },
    touchStart(e) {
      e = e || window.event;
      this.startX = e.touches[0].pageX;
      this.startY = e.touches[0].pageY;
    },
    touchEnd(e) {
      const that = this;
      // console.log(this)
      // console.log(e)
      this.endX = e.changedTouches[0].pageX;
      this.endY = e.changedTouches[0].pageY;
      this.isMove = true;
      that.upOrDown(this.startX, this.startY, this.endX, this.endY);
    },
    upOrDown(startX, startY, endX, endY) {
      const that = this;
      let direction = that.GetSlideDirection(startX, startY, endX, endY);

      switch (direction) {
        case 0:
          break;
        case 1:
          this.pageIndex += 1;
          if (this.pageIndex === this.refList.length) {
            this.pageIndex = this.refList.length - 1;
          }
          if (this.pageIndex != 1) {
            if (this.$refs[this.refList[1]].isActive == false) {
              this.$refs[this.refList[1]].changeHeight();
            }
          }
          setTimeout(() => {
            this.isMove = false;
          }, 500);
          break;
        case 2:
          this.pageIndex -= 1;
          if (this.pageIndex < 0) {
            this.pageIndex = 0;
          }
          if (this.pageIndex != 1) {
            if (this.$refs[this.refList[1]].isActive == false) {
              this.$refs[this.refList[1]].changeHeight();
            }
          }
          setTimeout(() => {
            this.isMove = false;
          }, 500);
          break;
        case 3:
          break;
        case 4:
          break;
        default:
          break;
      }
    },
    // 根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
    GetSlideDirection(startX, startY, endX, endY) {
      const that = this;
      let dy = startY - endY;
      let dx = endX - startX;
      let result = 0;
      // 如果滑动距离太短
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
        return result;
      }
      let angle = that.GetSlideAngle(dx, dy);
      if (angle >= -45 && angle < 45) {
        result = 4;
      } else if (angle >= 45 && angle < 135) {
        result = 1;
      } else if (angle >= -135 && angle < -45) {
        result = 2;
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 3;
      }
      return result;
    },
    // 返回角度
    GetSlideAngle(dx, dy) {
      return (Math.atan2(dy, dx) * 180) / Math.PI;
    },
  },
};
</script>
<style scoped>
.pe-bg {
  width: 100%;
  height: 500%;
  position: relative;
  top: 0;
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/pe-home/index.vue